<template>
  <form @submit.prevent="handleSubmit" :class="$style.formContainer">

    <!-- Багшийн хувьд зураг оруулах хэсэг -->
    <div v-if="userData.user_type === 2" :class="$style.imageSection">
      <label :class="$style.inputLabel">Профайл зураг</label>
      <Cropper v-if="isEditingImage" :class="$style.cropper" :src="currentImageUrl" @change="onCropChange"
        :stencil-props="{ aspectRatio: 1 }" />

      <img v-else-if="userData.imageUrl" :src="userData.imageUrl" :class="$style.profileImage" alt="Профайл зураг" />

      <div v-else :class="$style.uploadPlaceholder">
        <input type="file" @change="handleImageUpload" accept="image/*" :class="$style.fileInput" ref="fileInput" />
        <button type="button" @click="triggerFileInput" :class="$style.uploadButton">
          Зураг оруулах
        </button>
      </div>

      <div v-if="userData.imageUrl && !isEditingImage">
        <button type="button" @click="removeImage" :class="$style.removeButton">
          Зургийг устгах
        </button>
      </div>

      <div v-if="isEditingImage" :class="$style.imageControls">
        <button type="button" @click="saveImage" :class="$style.imageButton">
          Хадгалах
        </button>
        <button type="button" @click="cancelImageEdit" :class="$style.imageButton">
          Цуцлах
        </button>
      </div>
    </div>

    <!-- Хувийн мэдээлэл -->
    <div :class="$style.infoSection">
      <label :class="$style.inputLabel">Хувийн мэдээлэл</label>

      <input v-model="userData.firstname" :class="$style.input" type="text" placeholder="Нэр" required />

      <input v-model="userData.lastname" :class="$style.input" type="text" placeholder="Овог" required />

      <input v-model="userData.email" :class="$style.input" type="email" placeholder="Имэйл"  disabled />

      <input v-model="userData.phone" :class="$style.input" type="tel" placeholder="Утасны дугаар" required />
    </div>
    <div v-if="userData.user_type === 2" :class="$style.educationSection">
      <label :class="$style.inputLabel">Багшийн зэрэг, албан тушаал</label>
      <div :class="$style.learnListContainer">
        <ul>
          <li v-for="(item, index) in userData.degree" :key="index" :class="$style.learnItem">
            {{ item }}
            <button type="button" @click="removeDegree(index)" :class="$style.deleteButton">
              ×
            </button>
          </li>
        </ul>
        <div :class="$style.addItemContainer">
            <input v-model="newNewdegree" :class="$style.input" placeholder="Зэрэг, албан нэмэх"
            @keyup.enter="addEducation" />
          <button type="button" @click="addDegree" :class="$style.addButton">
            +
          </button>
        </div>
      </div>
    </div>
    <!-- Боловсролын мэдээлэл (Зөвхөн багшийн хувьд) -->
    <div v-if="userData.user_type === 2" :class="$style.educationSection">
      <label :class="$style.inputLabel">Багшийн танилцуулга</label>
      <div :class="$style.learnListContainer">
        <ul>
          <li v-for="(item, index) in userData.education" :key="index" :class="$style.learnItem">
            {{ item }}
            <button type="button" @click="removeEducation(index)" :class="$style.deleteButton">
              ×
            </button>
          </li>
        </ul>
        <div :class="$style.addItemContainer">
            <input v-model="newEducation" :class="$style.input" placeholder="Танилцуулга нэмэх"
            @keyup.enter="addEducation" />
          <button type="button" @click="addEducation" :class="$style.addButton">
            +
          </button>
        </div>
      </div>
    </div>
    

    <!-- Холбоосуудын хэсэг -->
    <div v-if="userData.user_type === 2" :class="$style.linksSection">
      <label :class="$style.inputLabel">Холбоосууд</label>
      <div :class="$style.learnListContainer">
        <ul>
          <li v-for="(link, index) in userData.links" :key="index" :class="$style.learnItem">
            <a :href="link" target="_blank" :class="$style.linkItem">
              {{ link }}
            </a>
            <button type="button" @click="removeLink(index)" :class="$style.deleteButton">
              ×
            </button>
          </li>
        </ul>
        <div :class="$style.addItemContainer">
          <input v-model="newLink" :class="$style.input" placeholder="Шинэ холбоос нэмэх" @keyup.enter="addLink"
            type="url" />
          <button type="button" @click="addLink" :class="$style.addButton">
            +
          </button>
        </div>
      </div>
    </div>

    <!-- Илгээх товч -->
    <div :class="$style.buttonContainer">
      <button type="submit" :class="$style.submitButton">
        Профайл шинэчлэх
      </button>
    </div>
  </form>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import axios from 'axios'

export default {
  name: 'UserProfile',
  components: { Cropper },
  data() {
    return {
      userData: {
        email: '',
        lastname: '',
        firstname: '',
        phone: '',
        user_type: 1,
        is_active: true,
        education: [],
        degree: [],
        links: [], // Add links here
        imageUrl: ''
      },
      isEditingImage: false,
      currentImageUrl: '',
      croppedImageData: null,
      newEducation: '',
      newNewdegree: '',
      newLink: '', // Add newLink for input
    }
  },

  created() {
    this.fetchUserData()
  },
  methods: {
    fetchUserData() {
      axios.get('/user_info')
        .then(response => {
          console.log(response.data);
          
          this.userData = {
            ...response.data,
            education: response.data.education || [],
            degree: response.data.degree || [],
            links: response.data.links || []
          }
        })
        .catch(error => {
          console.error('Хэрэглэгчийн мэдээллийг татаж чадсангүй:', error)
        })
    },

    triggerFileInput() {
      this.$refs.fileInput.click()
    },

    handleImageUpload(event) {
      const file = event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.currentImageUrl = e.target.result
          this.isEditingImage = true
        }
        reader.readAsDataURL(file)
      }
    },

    onCropChange(data) {
      this.croppedImageData = data.canvas.toDataURL()
    },

    saveImage() {
      if (this.croppedImageData) {
        this.userData.imageUrl = this.croppedImageData
        this.$alert.showAlert('Профайл зураг амжилттай шинэчлэгдлээ', 'success')
      }
      this.isEditingImage = false
    },

    cancelImageEdit() {
      this.isEditingImage = false
    },

    removeImage() {
      this.userData.imageUrl = ''
      this.$alert.showAlert('Профайл зураг устлаа', 'success')
    },

    addEducation() {
      if (this.newEducation.trim()) {
        this.userData.education.push(this.newEducation.trim())
        this.newEducation = ''
        this.$alert.showAlert('Багшийн танилцуулга амжилттай нэмэгдлээ', 'success')
      }
    },

    removeEducation(index) {
      this.userData.education.splice(index, 1)
      this.$alert.showAlert('Багшийн танилцуулга мэдээлэл устлаа', 'success')
    },

    addDegree() {
      if (this.newNewdegree.trim()) {
        this.userData.degree.push(this.newNewdegree.trim())
        this.newNewdegree = ''
        this.$alert.showAlert('Багшийн зэрэг, албан тушаал амжилттай нэмэгдлээ', 'success')
      }
    },

    removeDegree(index) {
      this.userData.degree.splice(index, 1)
      this.$alert.showAlert('Багшийн зэрэг, албан тушаал устлаа', 'success')
    },
    addLink() {
      const urlPattern = /^(https?:\/\/)?([\w.-]+)\.([a-z.]{2,6})([/\w.-]*)*\/?$/;
      if (this.newLink.trim() && urlPattern.test(this.newLink.trim())) {
        if (!this.userData.links.includes(this.newLink.trim())) {
          this.userData.links.push(this.newLink.trim());
          this.newLink = '';
          this.$alert.showAlert('Холбоос амжилттай нэмэгдлээ', 'success');
        } else {
          this.$alert.showAlert('Холбоос давхцаж байна', 'warning');
        }
      } else {
        this.$alert.showAlert('Холбоосын формат буруу байна', 'error');
      }
    },

    removeLink(index) {
      this.userData.links.splice(index, 1);
      this.$alert.showAlert('Холбоос устлаа', 'success');
    },
    handleSubmit() {
      console.log('this.userData', this.userData);
      
      axios.put('/user/update', this.userData)
        .then(() => this.$alert.showAlert('Профайл амжилттай шинэчлэгдлээ', 'success'))
        .catch(() => this.$alert.showAlert('Профайл шинэчлэхэд алдаа гарлаа', 'error'))
    }
  }
}
</script>


<style module>
:root {
  --primary-color: #2D5A87;
  /* Professional navy blue */
  --primary-hover: #1F4369;
  /* Darker blue for hover */
  --secondary-color: #5B9BD5;
  /* Lighter blue for secondary elements */
  --accent-color: #4A90E2;
  /* Bright blue for accents */
  --success-color: #43936C;
  /* Muted green for success */
  --error-color: #D64242;
  /* Softer red for errors */
  --warning-color: #E9B949;
  /* Warm yellow for warnings */
  --text-primary: #2C3E50;
  /* Dark blue-grey for primary text */
  --text-secondary: #566573;
  /* Medium grey for secondary text */
  --border-color: #CBD5E1;
  /* Soft grey for borders */
  --background-light: #F8FAFC;
  /* Very light grey for backgrounds */
  --background-hover: #EEF2F7;
  /* Slightly darker for hover states */
}

.wfSection {
  display: flex;
  justify-content: center;
  padding: 32px 20px;
  background-color: var(--background-light);
  min-height: 100vh;
}

.formContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: white;
  padding: 32px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}
/* Profile Image Section */
.imageSection {
  width: 100%;
  max-width: 700px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
}

.profileImage {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  margin: 20px 0;
  border: 4px solid var(--background-light);
}

.uploadPlaceholder {
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--background-light);
  border-radius: 50%;
  border: 2px dashed var(--border-color);
  margin: 20px 0;
  transition: all 0.3s ease;
}

.uploadPlaceholder:hover {
  border-color: var(--primary-color);
  background-color: var(--background-hover);
}

.fileInput {
  display: none;
}

.uploadButton {
  padding: 12px 24px;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.uploadButton:hover {
  background-color: var(--primary-hover);
  transform: translateY(-1px);
}

.imageControls {
  display: flex;
  gap: 16px;
  margin-top: 16px;
}

.imageButton {
  padding: 10px 20px;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.imageButton:hover {
  background-color: var(--primary-hover);
}

.removeButton {
  padding: 10px 20px;
  background-color: var(--error-color);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  margin-top: 16px;
  transition: all 0.3s ease;
}

.removeButton:hover {
  background-color: var(--error-color);
  opacity: 0.9;
  transform: translateY(-1px);
}

/* Form Fields */
.infoSection {
  width: 100%;
  max-width: 700px;
  margin-bottom: 32px;
}

.inputLabel {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 12px;
  display: block;
}

.input {
  width: 100%;
  padding: 14px 16px;
  margin-bottom: 16px;
  border: 2px solid var(--border-color);
  border-radius: 12px;
  font-size: 16px;
  color: var(--text-primary);
  transition: all 0.3s ease;
  background-color: white;
}

.input:hover {
  border-color: var(--secondary-color);
}

.input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);
}

/* Education Section */
.educationSection {
  width: 100%;
  max-width: 700px;
  margin-bottom: 32px;
}

.learnListContainer {
  margin-top: 16px;
}

.learnItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: var(--background-light);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  margin-bottom: 8px;
  transition: all 0.3s ease;
  color: var(--text-primary);
}

.learnItem:hover {
  background-color: var(--background-hover);
  border-color: var(--secondary-color);
}

.addItemContainer {
  display: flex;
  gap: 12px;
  margin-top: 16px;
}

.learnInputList {
  flex: 1;
  padding: 14px 16px;
  border: 2px solid var(--border-color);
  border-radius: 12px;
  font-size: 16px;
  color: var(--text-primary);
  transition: all 0.3s ease;
}

.learnInputList:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);
}

.addButton {
  width: 48px;
  height: 48px;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.addButton:hover {
  background-color: var(--primary-hover);
  transform: translateY(-1px);
}

.deleteButton {
  background-color: var(--error-color);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.deleteButton:hover {
  background-color: var(--error-color);
  opacity: 0.9;
  transform: translateY(-1px);
}

/* Submit Button */
.buttonContainer {
  width: 100%;
  max-width: 700px;
  display: flex;
  justify-content: center;
  margin-top: 32px;
}

.submitButton {
  padding: 16px 40px;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  transition: all 0.3s ease;
  min-width: 200px;
}

.submitButton:hover {
  background-color: var(--primary-hover);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(45, 90, 135, 0.2);
}

.submitButton:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Cropper Styles */
.cropper {
  width: 100%;
  max-width: 500px;
  height: 300px;
  background-color: var(--background-light);
  margin: 20px 0;
  border-radius: 12px;
  overflow: hidden;
}

/* Loading Overlay */
.loadingOverlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid var(--background-light);
  border-top: 5px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* Responsive Design */
@media (max-width: 640px) {
  .formContainer {
    padding: 20px;
  }

  .alert {
    width: 90%;
    min-width: auto;
    left: 5%;
    right: 5%;
  }

  .uploadButton {
    width: 100%;
  }

  .imageControls {
    flex-direction: column;
    width: 100%;
  }

  .imageButton {
    width: 100%;
  }

  .submitButton {
    width: 100%;
  }
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    transition-duration: 0.01ms !important;
  }
}

/* Focus States */
button:focus,
input:focus {
  outline: 3px solid var(--accent-color);
  outline-offset: 2px;
}

/* High Contrast Support */
@media (prefers-contrast: high) {

  .input,
  .learnInputList {
    border-width: 2px;
  }

  .submitButton,
  .uploadButton,
  .addButton {
    border: 2px solid #000;
  }
}
.linksSection {
  width: 100%;
  max-width: 700px;
  margin-bottom: 32px;
}

.linkItem {
  color: var(--accent-color);
  text-decoration: none;
  word-break: break-all;
}

.linkItem:hover {
  text-decoration: underline;
}
</style>